module.exports = __webpack_public_path__ + "static/lundi27Geometry-231334b3bdda0a6ecf6109243f6b29dd.jpg";